import { BaseClass } from './base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { Client } from './client';
import { ProductType } from './productType';

export class Container extends BaseClass implements BaseRepository {
    client: Client;
    description: string;
    identifier: string;
    tag: string;
    productType: ProductType;

    constructor()
    constructor(
      client: Client, description: string, identifier: string, tag: string, productType: ProductType)
    constructor(
      client?: Client, description?: string, identifier?: string, tag?: string, productType?: ProductType) {
        super();

        this.client = client || null;
        this.description = this.trim(description);
        this.identifier = identifier;
        this.tag = tag;
        this.productType = productType;
    }

    static fromObject(object: Container): Container {
        return Object.assign(new Container(), {
          ...object,
            client: object.client ? Client.fromObject(object.client) : null,
            productType: object.productType ? ProductType.fromObject(object.productType) : null
        });
    }

    get display(): string {
        return `${this.description}`;
    }

    doesInclude(value: string): boolean {
        return this.some([this.description], value);
    }
}
